var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"pa-2"},[_c('v-row',{staticClass:"ma-0"},_vm._l((_vm.indicators),function(indicator){return _c('div',{key:indicator.key,staticClass:"col-6 col-lg-3 col-xl-2 pl-0 pb-0"},[_c('LabelWithValue',{attrs:{"label":indicator.label,"value":_vm.formatValue(indicator)}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }